import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'

const selectNotificationEntities = (state: RootState) =>
  state.notifications?.entities ?? {}

export const selectUnreadNotifications = createSelector(
  [selectNotificationEntities],
  (entities) => {
    return Object.values(entities)
      .filter((n) => !n?.read && n?.displayType === 'modal')
      .sort((a, b) => (a?.timestamp ?? 0) - (b?.timestamp ?? 0))
  }
)

export const selectIsNotificationActive = createSelector(
  [selectUnreadNotifications],
  (notifications) => notifications?.length > 0
)
